/**
 * 获取随机串
 */
const getRandomString = (length: number): String => {
  return Math.random().toString().substr(2, length);
};
/**
* 获取唯一id
* @param {Number} length 获取的id的长度
*/
export default (length = 16) => {
  // eslint-disable-next-line no-param-reassign
  length = length > 8 ? length - 8 : 0;
  return getRandomString(length) + (Number(getRandomString(length)) + Date.now()).toString(36);
};
